module.exports = __webpack_public_path__ + "img/slogan_zhTc.c004aa55.png";